var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7536",
    "data-name": "Group 7536",
    transform: "translate(6096 8575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2169",
    "data-name": "Rectangle 2169",
    width: 22,
    height: 22,
    transform: "translate(-6096 -8575)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "store",
    transform: "translate(-6096 -8621.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7533",
    "data-name": "Group 7533",
    transform: "translate(0 48.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7532",
    "data-name": "Group 7532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11439",
    "data-name": "Path 11439",
    d: "M21.877,53.1l-3.437-4.812A.717.717,0,0,0,17.875,48H4.125a.717.717,0,0,0-.564.289L.124,53.1,0,53.475a2.755,2.755,0,0,0,2.75,2.777,2.726,2.726,0,0,0,2.062-.935,2.742,2.742,0,0,0,4.125,0,2.742,2.742,0,0,0,4.125,0,2.742,2.742,0,0,0,4.125,0,2.726,2.726,0,0,0,2.062.935A2.755,2.755,0,0,0,22,53.475Z",
    transform: "translate(0 -48.003)",
    fill: "#63666f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7535",
    "data-name": "Group 7535",
    transform: "translate(1.375 57.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7534",
    "data-name": "Group 7534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11440",
    "data-name": "Path 11440",
    d: "M49.878,259.63a4.114,4.114,0,0,1-2.062-.555,4.213,4.213,0,0,1-4.125,0,4.213,4.213,0,0,1-4.125,0,4.213,4.213,0,0,1-4.125,0,4.181,4.181,0,0,1-3.437.287v7.143a1.376,1.376,0,0,0,1.375,1.375h11v-6.875H48.5v6.875h1.375a1.376,1.376,0,0,0,1.375-1.375v-7.127A4.1,4.1,0,0,1,49.878,259.63Zm-9.625,5.5h-5.5v-4.125h5.5Z",
    transform: "translate(-32.003 -259.075)",
    fill: "#63666f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.69b6cfbaddd7a87400761a462edda7c0.svg";
export { ForwardRef as ReactComponent };